module.exports = __webpack_public_path__ + "img/ico_telegram.960f55a2.svg";